type TimetableWithVersions = {
  uuid: string;
  name: string;
  versions: { active: boolean; classUuids: string[] }[];
};

/** Klassen, die ein Stundenplan im Abschnitt belegt: die der aktiven Version, ohne aktive die aller Versionen. */
export const getTimetableClassUuids = (timetable: TimetableWithVersions): Set<string> => {
  const active = timetable.versions.filter((version) => version.active);
  return new Set((active.length > 0 ? active : timetable.versions).flatMap((version) => version.classUuids));
};

const sharesClass = (a: Set<string>, b: Set<string>) => [...a].some((classUuid) => b.has(classUuid));

/**
 * Ein Abschnitt darf keine zwei Stundenpläne mit gemeinsamen Klassen enthalten.
 * - `blocked`: nicht gewählte Stundenpläne, die eine Klasse mit einem gewählten teilen (nicht mehr wählbar);
 * - `conflicting`: gewählte Stundenpläne, die eine Klasse miteinander teilen (Formular ungültig).
 */
export const findTimetableClassConflicts = (selectedUuids: string[], timetables: TimetableWithVersions[]) => {
  const selected = new Set(selectedUuids);
  const classes = new Map(timetables.map((timetable) => [timetable.uuid, getTimetableClassUuids(timetable)]));
  const selectedTimetables = timetables.filter((timetable) => selected.has(timetable.uuid));

  const blocked = new Set(
    timetables
      .filter((timetable) => !selected.has(timetable.uuid))
      .filter((timetable) =>
        selectedTimetables.some((other) => sharesClass(classes.get(timetable.uuid)!, classes.get(other.uuid)!)),
      )
      .map((timetable) => timetable.uuid),
  );

  const conflicting = selectedTimetables.filter((timetable) =>
    selectedTimetables.some(
      (other) => other.uuid !== timetable.uuid && sharesClass(classes.get(timetable.uuid)!, classes.get(other.uuid)!),
    ),
  );

  return { blocked, conflicting };
};
